/**
 * Constants for SQLFlow Deploy
 */

export const DB_VENDORS = [
  { value: 'athena', label: 'AWS Athena' },
  { value: 'azuresql', label: 'Azure SQL' },
  { value: 'bigquery', label: 'Google BigQuery' },
  { value: 'clickhouse', label: 'ClickHouse' },
  { value: 'couchbase', label: 'Couchbase' },
  { value: 'dameng', label: 'Dameng Database' },
  { value: 'databricks', label: 'Databricks' },
  { value: 'db2', label: 'IBM DB2' },
  { value: 'doris', label: 'Apache Doris' },
  { value: 'duckdb', label: 'DuckDB' },
  { value: 'edb', label: 'EDB Postgres Advanced Server' },
  { value: 'flink', label: 'Apache Flink SQL' },
  { value: 'gaussdb', label: 'GaussDB' },
  { value: 'greenplum', label: 'Greenplum' },
  { value: 'hana', label: 'SAP HANA' },
  { value: 'hive', label: 'Apache Hive' },
  { value: 'impala', label: 'Apache Impala' },
  { value: 'informix', label: 'IBM Informix' },
  { value: 'mdx', label: 'MDX' },
  { value: 'mssql', label: 'Microsoft SQL Server' },
  { value: 'mysql', label: 'MySQL' },
  { value: 'netezza', label: 'IBM Netezza' },
  { value: 'oceanbase', label: 'OceanBase' },
  { value: 'odbc', label: 'ODBC' },
  { value: 'openedge', label: 'Progress OpenEdge' },
  { value: 'oracle', label: 'Oracle' },
  { value: 'postgresql', label: 'PostgreSQL' },
  { value: 'powerquery', label: 'Power Query M Language' },
  { value: 'presto', label: 'Presto' },
  { value: 'redshift', label: 'Amazon Redshift' },
  { value: 'snowflake', label: 'Snowflake' },
  { value: 'soql', label: 'Salesforce SOQL' },
  { value: 'sparksql', label: 'Apache Spark SQL' },
  { value: 'sqlite', label: 'SQLite' },
  { value: 'starrocks', label: 'StarRocks' },
  { value: 'sybase', label: 'Sybase' },
  { value: 'teradata', label: 'Teradata' },
  { value: 'trino', label: 'Trino' },
  { value: 'vertica', label: 'Vertica' },
] as const;

export const LICENSE_TYPES = [
  { value: 'enterprise', label: 'Enterprise' },
  { value: 'machine_code', label: 'Machine Code' },
] as const;

export const DEFAULT_MACHINE_VALUES = {
  product_name: 'Gudu SQLFlow',
  product_license: 'Site',
  available_days: 365,
  license_type: 'machine_code' as const,
};

// Product versions (can be fetched from API in the future)
export const PRODUCT_VERSIONS = [
  '6.5.0',
  '6.4.0',
  '6.3.0',
  '6.2.0',
  '6.1.0',
  '6.0.0',
  '5.9.0',
  '5.8.0',
];
